export default {
    stickers: {
        title: 'Adesivi',
        stickerOpacity: "Opacità dell'adesivo",
        stickerColor: 'Colore adesivo',
        shapes: {
            title: 'Forme',
            rectangle: 'Rettangolo',
            circle: 'Cerchio',
            triangle: 'Triangolo',
        },
        emojis: {
            title: 'Emoji',
        },
    },
};
